export const programmingLanguages = [
    { value: 'C++', label: 'C++' },
    { value: 'Java', label: 'Java' },
    { value: 'Python', label: 'Python' },
    { value: 'Python3', label: 'Python3' },
    { value: 'MySQL', label: 'MySQL' },
    { value: 'MS SQL Server', label: 'MS SQL Server' },
    { value: 'Oracle SQL', label: 'Oracle SQL' },
    { value: 'C', label: 'C' },
    { value: 'C#', label: 'C#' },
    { value: 'JavaScript', label: 'JavaScript' },
    { value: 'Ruby', label: 'Ruby' },
    { value: 'Bash', label: 'Bash' },
    { value: 'Swift', label: 'Swift' },
    { value: 'Go', label: 'Go' },
    { value: 'Scala', label: 'Scala' },
    { value: 'Kotlin', label: 'Kotlin' },
    { value: 'Rust', label: 'Rust' },
    { value: 'PHP', label: 'PHP' },
    { value: 'TypeScript', label: 'TypeScript' },
    { value: 'Racket', label: 'Racket' },
    { value: 'Erlang', label: 'Erlang' },
    { value: 'Elixir', label: 'Elixir' },
    { value: 'Dart', label: 'Dart' },
    { value: 'PostgreSQL', label: 'PostgreSQL' },
    { value: 'Pandas', label: 'Pandas' },
    { value: 'React', label: 'React' },
    { value: 'Vanilla JS', label: 'Vanilla JS' },
];

export const programmingLanguageOptions = [
    'C++',
    'Java',
    'Python',
    'Python3',
    'MySQL',
    'MS SQL Server',
    'Oracle SQL',
    'C',
    'C#',
    'JavaScript',
    'Ruby',
    'Bash',
    'Swift',
    'Go',
    'Scala',
    'Kotlin',
    'Rust',
    'PHP',
    'TypeScript',
    'Racket',
    'Erlang',
    'Elixir',
    'Dart',
    'PostgreSQL',
    'Pandas',
    'React',
    'Vanilla JS',
];
